module.exports = __webpack_public_path__ + "3f75b6b5d175767cd6b24d1f45ca5027.png";